/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-03 16:28:34
 * @LastEditTime: 2024-09-27 09:18:35
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\userMaage\login\index.tsx
 * @Description: 登录页面
 */
import { CommmonGet, CommmonPostNoBody } from '@/util/network/api';
import { CheckPhone, decryptData } from '@/util/public';
import { Form, message } from 'antd';
import { LgButton, LgInput } from 'lancoo-web-ui';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLoginShow, setUserId } from '../../../store/reducers/userInfo';
import { service } from '../data';
import NameIcon from '../images/姓名.svg';
import SecureIcon from '../images/安全.svg';
import PasswordIcon from '../images/密码.svg';
import PhoneIcon from '../images/手机.svg';


const Login: React.FC<any> = (props: any) => {
  const {
    form,
    onForget,
    onRegister,
    onSelectLoginUser,
    setIsloading
  } = props;

  const dispatch = useDispatch();

  const [, setState1] = useState<any>({});
  const [loginType, setLoginType] = useState<string>('user');
  const [countdown, setCountdown] = useState<number>(60); // 倒计时秒数
  const [timingShow, setTimingShow] = useState<boolean>(false);

  useEffect(() => {
    const storedUsername = localStorage.getItem(`${process.env.REACT_APP_SYSTERM_ID}_idCard`);
    const storedPassword = localStorage.getItem(`${process.env.REACT_APP_SYSTERM_ID}_password`);

    if (storedUsername && storedPassword) {
      const encryptedUsername = JSON.parse(storedUsername);
      const encryptedPassword = JSON.parse(storedPassword);

      const decryptedUsername = encryptedUsername;
      const decryptedPassword = decryptData(encryptedPassword);

      form.setFieldsValue({
        idCard: decryptedUsername,
        password: decryptedPassword,
        enable: true
      })
      setState1({});
    }
  }, []);

  const submit = () => {
    form.validateFields().then(formRes => {
      let data = loginType === 'user' ? {
        username: formRes.idCard,
        password: formRes.password,
      } : {
        username: formRes.phone,
        code: formRes.code
      }
      setIsloading(true);
      CommmonPostNoBody(service[loginType === 'user' ? 'login' : 'smsLogin'], data).then((res: any) => {
        const resData = Array.isArray(res?.data) ? res?.data[0] : res?.data
        // 处理登录成功后的逻辑
        if (res?.data?.length > 1) {
          onSelectLoginUser(res.data, formRes[loginType === 'user' ? 'idCard' : 'phone']);
          return
        } else {
          message.success("登陆成功");
          dispatch(setUserId(resData?.userId));
          dispatch(setLoginShow(false));
        }

        // 记住密码
        // if (formRes.enable) {
        //   const encryptedPassword = encryptData(formRes.password);
        //   localStorage.setItem(`${process.env.REACT_APP_SYSTERM_ID}_idCard`, JSON.stringify(formRes.idCard));
        //   localStorage.setItem(`${process.env.REACT_APP_SYSTERM_ID}_password`, JSON.stringify(encryptedPassword));
        // } else {
        //   localStorage.removeItem(`${process.env.REACT_APP_SYSTERM_ID}_idCard`);
        //   localStorage.removeItem(`${process.env.REACT_APP_SYSTERM_ID}_password`);
        // }
      }).catch(error => {
        if (error.message) {
          message.warning(error.message, 2);
        }
      }).finally(() => {
        setIsloading(false);
      });
    }).catch(error => {
      console.log(error);
    });
  };

  /**
   * @description: 获取注册验证码
   * @param {*} void
   * @return {*}
   */
  const getLoginCode = (): void => {
    // 禁用获取验证码按钮
    const formData = form.getFieldsValue();
    if (formData.phone) {
      if (!CheckPhone(formData.phone)) {
        message.warning('手机号格式有误', 2);
        return;
      }
      // 判断是否已经注册
      setIsloading(true);
      CommmonGet(service.checkPhone, {
        phone: formData.phone
      }).then((res: any) => {
        message.destroy();
        if (res?.data?.status == 4) {
          setIsloading(true);
          CommmonGet(service.sendLoginSmsCode, {
            phone: formData.phone,
            type: 5
          }).then(res => {
            message.success("发送成功");
            startCountdown();
          }).catch(err => {
          }).finally(() => {
            setIsloading(false);
          });
        } else {
          message.warning("该手机号未注册");
        }
      }).finally(() => {
        setIsloading(false);
      });

    } else {
      message.warning('请输入手机号', 2);
    }
  };
  /**
  * @description: 倒计时
  * @return {*}
  */
  const startCountdown = () => {
    setTimingShow(true)
    let timer = setInterval(() => {
      setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000);

    setTimeout(() => {
      setTimingShow(false)
      clearInterval(timer);
      setCountdown(60); // 重置倒计时秒数为60
    }, countdown * 1000);
  };
  /**
   * @description: 按钮回车事件
   * @param {*} event
   * @return {*}
   */
  const handleKeyDown = event => {
    if (event.keyCode === 13) {
      console.log('Enter key pressed');
      // 在这里执行你想要执行的操作
      submit()
    }
  }

  return (
    <>
      <div className='login_type' style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
        <div className={loginType === 'user' ? 'active' : ''} onClick={() => setLoginType('user')}>
          账号登录
        </div>
        <div className='split' />
        <div className={loginType === 'smsCode' ? 'active' : ''} onClick={() => setLoginType('smsCode')}>
          验证码登录
        </div>
      </div>
      {loginType === 'user' && <>
        <Form.Item
          style={{ position: 'relative', marginBottom: 0 }}
          className='form_icon'
        >
          <div className='form_icon_div' style={{ background: `url(${NameIcon}) no-repeat center` }} />
          <Form.Item
            name="idCard"
            rules={[
              { required: true, message: '用户名不能为空' }
            ]}
            style={{ marginBottom: 16 }}
          >
            <LgInput
              bigWidth
              input={{ placeholder: "请输入用户名/手机号/身份证号" }}
              size='oversized'
              style={{ height: 48 }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          style={{ position: 'relative', marginBottom: 0 }}
          className='form_icon'
        >
          <div className='form_icon_div' style={{ background: `url(${PasswordIcon}) no-repeat center` }} />
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
            style={{ marginBottom: 16 }}
            className='password'
          >
            <LgInput
              bigWidth
              maxLength={20}
              input={{ placeholder: "请输入密码", type: 'password' }}
              size='oversized'
              onKeyDown={handleKeyDown}
              style={{ height: 48 }}
            />
          </Form.Item>
          <span
            className='onclik_cls'
            onClick={onForget}
            style={{
              position: 'absolute',
              top: 0,
              right: '16px',
              lineHeight: '48px'
            }}
          >
            忘记密码
          </span>
        </Form.Item>
      </>}
      {loginType === 'smsCode' && <>
        <Form.Item
          style={{ position: 'relative', marginBottom: 0 }}
          className='form_icon'
        >
          <div className='form_icon_div' style={{ background: `url(${PhoneIcon}) no-repeat center` }} />
          <Form.Item
            name="phone"
            rules={[
              { required: true, message: '请输入手机号' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || CheckPhone(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('手机号格式有误'));
                },
              }),
            ]}
            style={{ marginBottom: 16 }}
          >
            <LgInput
              bigWidth
              input={{ placeholder: "请输入手机号" }}
              size='oversized'
              style={{ height: 48 }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          style={{ position: 'relative', marginBottom: 0 }}
        >
          <Form.Item
            style={{ position: 'relative', marginBottom: 0 }}
            className='form_icon'
          >
            <div className='form_icon_div' style={{ background: `url(${SecureIcon}) no-repeat center` }} />
            <Form.Item
              name="code"
              rules={[{ required: true, message: '请输入验证码' }]}
              style={{ marginBottom: 16 }}
              className='item_code'
            >
              <LgInput
                bigWidth
                input={{ placeholder: "请输入验证码" }}
                size='oversized'
                onKeyDown={handleKeyDown}
                style={{ height: 48 }}
              />
            </Form.Item>
            {timingShow ?
              <div
                className='form_ss'
                style={{
                  color: '#999999',
                  cursor: 'default'
                }}
              >
                ({countdown}秒后重新获取)
              </div> :
              <span
                className='onclik_cls'
                onClick={getLoginCode}
                style={{
                  position: 'absolute',
                  top: 0,
                  right: '20px',
                  lineHeight: '48px'
                }}
              >
                获取验证码
              </span>
            }
          </Form.Item>
        </Form.Item>
      </>}

      <Form.Item style={{ marginBottom: 32 }}>
        <LgButton
          onClick={submit}
          backgroundType='opacification'
          type='info'
          size='super'
          style={{ justifyContent: 'center', width: 360 }}
        >
          登录
        </LgButton>
      </Form.Item>
      <div>
        <span style={{ color: '#999999' }}>还没有账号?</span>
        <span className='onclik_cls' onClick={onRegister}>立即注册</span>
      </div>
    </>
  );
};

export default Login;
